<template>
  <div
    class="squircle-lg relative flex flex-col rounded border p-2 text-center"
  >
    <LoadingComponent v-if="!data" size="small" :display-label="false" />
    <template v-else>
      <RouterLink
        class="squircle-lg absolute top-2 right-2 flex size-6 items-center justify-center rounded border"
        :to="{
          name: 'analytics_element_route_id',
          params: { dashboardId, analyticsId: element.id }
        }"
      >
        <FontAwesomeIcon
          :icon="['fal', 'chart-mixed']"
          class="self-center"
          size="xs"
        />
      </RouterLink>
      <div class="flex flex-row items-baseline justify-center gap-2">
        <RouterLink
          as="h4"
          class="group flex items-center gap-1.5 text-base font-semibold hover:underline"
          :to="{
            name: 'analytics_element_route_id',
            params: { dashboardId, analyticsId: element.id }
          }"
        >
          {{ element.title }}
          <FontAwesomeIcon
            :icon="['fal', 'chevron-right']"
            class="w-3 shrink-0 text-gray-400 group-hover:text-gray-600"
            size="xs"
          />
        </RouterLink>
        <span
          v-if="evolutionPercent !== null"
          class="absolute right-1 bottom-1 text-sm font-semibold"
          :class="{
            'text-green-500': evolutionPercent > 0,
            'text-red-500': evolutionPercent < 0
          }"
        >
          {{ evolutionPercent > 0 ? '+' : '' }}{{ evolutionPercent }}%
        </span>
      </div>
      <div
        class="m-auto inline-flex flex-row flex-wrap items-baseline justify-around gap-x-3 lg:px-4"
      >
        <h3
          class="font-bold"
          :class="{
            'text-3xl': data.base?.value.toString().length <= 5,
            'text-xl': data.base?.value.toString().length > 5
          }"
        >
          <template v-if="dataType === 'scalar'">
            {{ data.base?.value }}
          </template>
          <template v-else-if="dataType === 'currency'">
            {{ $h.formatCurrency(data.base?.value ?? 0, currency) }}
          </template>
        </h3>
        <h4
          v-if="data.compare"
          class="font-semibold"
          :class="{
            'text-xl': data.compare.value.toString().length <= 5,
            'text-base': data.compare.value.toString().length > 5
          }"
        >
          <template v-if="dataType === 'scalar'">
            {{ data.compare?.value }}
          </template>
          <template v-else-if="dataType === 'currency'">
            {{ $h.formatCurrency(data.compare?.value ?? 0, currency) }}
          </template>
        </h4>
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import LoadingComponent from '@c/TheLoadingComponent.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { mapGetters } from 'vuex'

export default defineComponent({
  name: 'SimpleTile',
  components: { FontAwesomeIcon, LoadingComponent },
  props: {
    element: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    dataType: {
      type: String,
      required: false,
      default: 'scalar'
    },
    dashboardId: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      currency: 'metadata/getDefaultCurrencyMetadata'
    }),
    evolutionPercent() {
      const base = this.data?.base?.value
      const compare = this.data?.compare?.value
      if (base == null || compare == null || Number(compare) === 0) {
        return null
      }
      return Math.round(((Number(base) - Number(compare)) / Math.abs(Number(compare))) * 100)
    }
  }
})
</script>
